import React, { FC } from "react";
import { IPadding, IVisibleLayer } from "../Map/mapProvider";

export interface IDemoPaddingControl {
  onChangePadding: (padding: IPadding) => void;
}

export const DemoPaddingControl: FC<IDemoPaddingControl> = ({
  onChangePadding,
}: IDemoPaddingControl) => {
  const padding = { left: 300, duration: 500 };
  const setPadding = () => {
    const leftPadding = document.getElementById("padding-left");
    leftPadding.style.width = padding.left + "px";
    if (padding.duration !== undefined) {
      leftPadding.style.transitionDuration = padding.duration + "ms";
    }

    onChangePadding(padding);
  };
  return (
    <div className="list padding">
      <input
        type="number"
        placeholder="left (px)"
        onChange={(e) => (padding.left = Number(e.target.value))}
      />
      <input
        type="text"
        placeholder="duration (ms)"
        onChange={(e) => (padding.duration = Number(e.target.value))}
      />
      <button title={"set-padding"} onClick={setPadding}>
        Mainīt Padding
      </button>
    </div>
  );
};

export interface IDemoMapVisibilityControl {
  onMapToggle: (isMapVisible: boolean) => void;
}
export const DemoMapVisibilityControl: FC<IDemoMapVisibilityControl> = ({
  onMapToggle,
}: IDemoMapVisibilityControl) => {
  return (
    <div className="list-item">
      <input
        type="checkbox"
        id={"show-map"}
        title={"show-map"}
        defaultChecked={true}
        onChange={(e) => onMapToggle(e.target.checked)}
      ></input>
      <label htmlFor={"show-map"}>{"Rādīt karti"}</label>
    </div>
  );
};
